import { useDispatch, useSelector } from 'react-redux';
import { selectEligibleOffers, setOffers } from '../../../store/slices/OfferSlice';
import { useEffect } from 'react';
import { CompleteBasketItem } from '../../../providers/BasketProvider';
import { selectHasCachedOrderPromoCode } from '../../../store/slices/OrderSlice';

const useAutoApplyBestOffer = (items: CompleteBasketItem[]) => {
  const eligibleOffers = useSelector(selectEligibleOffers);
  const hasPromoCode = useSelector(selectHasCachedOrderPromoCode);
  const dispatch = useDispatch();

  const applyBestOfferHandler = (): void => {
    dispatch(setOffers({ appliedOffers: eligibleOffers }));
  };

  useEffect(() => {
    if (hasPromoCode) {
      return;
    }

    applyBestOfferHandler();
  }, [items, eligibleOffers, hasPromoCode]);
};

export default useAutoApplyBestOffer;
